import Box from "@cloudscape-design/components/box"
import ColumnLayout from "@cloudscape-design/components/column-layout"
import Container from "@cloudscape-design/components/container"

interface StatItem {
  /**
   * Numeric value to display.
   */
  value: number
  /**
   * Label describing the stat.
   */
  label: string
}

interface ProtocolStatsSummaryProps {
  /**
   * Array of stat items to display.
   */
  stats: StatItem[]
  /**
   * Visual variant for different contexts.
   */
  variant?: "default" | "compact"
}

/**
 * Displays a row of protocol statistics (visits, assessments, etc.).
 *
 * Used in pending review and approved views to show summary counts extracted from protocol data.
 */
const ProtocolStatsSummary = ({ stats, variant = "default" }: ProtocolStatsSummaryProps) => {
  const content = (
    <ColumnLayout columns={stats.length} variant="text-grid">
      {stats.map((stat, i) => (
        <div key={i}>
          <Box variant="awsui-value-large">{stat.value}</Box>
          <Box variant="awsui-key-label">{stat.label}</Box>
        </div>
      ))}
    </ColumnLayout>
  )

  if (variant === "compact") {
    return (
      <Box margin={{ bottom: "l" }}>
        <Container>{content}</Container>
      </Box>
    )
  }

  return <Box margin={{ bottom: "l" }}>{content}</Box>
}

export default ProtocolStatsSummary
